import {Component, Inject, OnDestroy, OnInit, Optional, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Observable, Subscription} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AppMatAutocompleteComponent} from '@xmedical/ui';
import {DiagnosisCode, MasterDataRepositoryService, Medication, MedicationRepositoryService} from '@xmedical/core';

@Component({
    selector: 'app-medication-item-add-card',
    templateUrl: './medication-item-add-card.component.html',
    styleUrls: ['./medication-item-add-card.component.scss'],
    standalone: false
})
export class MedicationItemAddCardComponent implements OnInit, OnDestroy {

  validate = false;
  form: UntypedFormGroup;
  diagnosisCode: DiagnosisCode = null;
  @ViewChild('diagnosisAutocomplete') diagnosisAutocomplete: AppMatAutocompleteComponent;
  private repositorySubscription: Subscription;

  constructor(
    private dialogRef: MatDialogRef<MedicationItemAddCardComponent>,
    private formBuilder: UntypedFormBuilder,
    private medicationRepository: MedicationRepositoryService,
    private masterDataRepository: MasterDataRepositoryService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { searchTerm?: string }) {
  }

  get hasDiagnosisCode(): boolean {
    return this.diagnosisCode !== null;
  }

  searchDiagnosisCodes$ = (query: string): Observable<DiagnosisCode[]> => {
    return this.masterDataRepository.searchDiagnosisCodes(query);
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: [this.data?.searchTerm || '', Validators.required],
      dosage: ['', Validators.required],
      diagnosisCode: ['', Validators.required],
      comment: [''],
      textColour: ['']
    });
  }

  ngOnDestroy(): void {
    if (this.repositorySubscription) {
      this.repositorySubscription.unsubscribe();
    }
  }

  save() {
    this.validate = true;
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const medication = this.formToMedication();
      this.repositorySubscription = this.medicationRepository.createMedicationItem(medication).subscribe(id => {
        medication.id = id;
        this.dialogRef.close(medication);
      });
    }
  }

  close() {
    this.dialogRef.close();
  }

  diagnosisCodeSelected(code: DiagnosisCode) {
    this.diagnosisCode = code;
    this.form.get('diagnosisCode').patchValue(code.code);
    this.form.updateValueAndValidity();
    this.diagnosisAutocomplete?.cancelSearch();
  }

  clearDiagnosisCode() {
    this.diagnosisCode = null;
    this.form.get('diagnosisCode').setValue('');
    this.form.updateValueAndValidity();
  }

  private formToMedication(): Medication {
    return this.form.value as Medication;
  }
}
